<template>
  <div>
    <div class="row">
      <div class="col-lg-7 col-md-6 col-sm-6 col-12" v-if="true">
        <div class="card card-statistic-1">
          <div class="card-icon bg-secondary">
            <i class="fas fa-clock"></i>
          </div>
          <div class="card-wrap">
            <div class="card-header"><h4>Data e Hora de Execução</h4></div>
            <div class="card-body">
              <div v-if="analytics.log_date == null && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ formatDate(analytics.log_date) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-md-6 col-sm-6 col-12">
        <div class="card card-statistic-1">
          <div class="card-icon bg-success"><i class="fas fa-list"></i></div>
          <div class="card-wrap">
            <div class="card-header"><h4>Total de Itens</h4></div>
            <div class="card-body">
              <div v-if="(analytics.total == 0 || analytics.total == null) && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ analytics.total || 0 }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 col-12">
        <div class="card card-statistic-1">
          <div class="card-icon bg-success"><i class="fas fa-plus-circle"></i></div>
          <div class="card-wrap">
            <div class="card-header"><h4>Atividades Criadas</h4></div>
            <div class="card-body">
              <div v-if="(analytics.created == 0 || analytics.created == null) && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ analytics.created || 0 }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 col-12">
        <div class="card card-statistic-1">
          <div class="card-icon bg-danger"><i class="fas fa-exclamation-triangle"></i></div>
          <div class="card-wrap">
            <div class="card-header"><h4>Atividades com Erro</h4></div>
            <div class="card-body">
              <div v-if="(analytics.error == 0 || analytics.error == null) && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ analytics.error || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="card card-statistic-1">
          <div class="card-icon bg-secondary"><i class="fas fa-calendar-day"></i></div>
          <div class="card-wrap">
            <div class="card-header"><h4>Total (dia anterior)</h4></div>
            <div class="card-body">
              <div v-if="(analytics.total_prev_day == 0 || analytics.total_prev_day == null) && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ analytics.total_prev_day || 0 }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="card card-statistic-1">
          <div class="card-icon bg-success"><i class="fas fa-check-circle"></i></div>
          <div class="card-wrap">
            <div class="card-header"><h4>Geradas (base dia anterior)</h4></div>
            <div class="card-body">
              <div v-if="(analytics.generated_based_on_prev == 0 || analytics.generated_based_on_prev == null) && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ analytics.generated_based_on_prev || 0 }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="card card-statistic-1">
          <div class="card-icon bg-danger"><i class="fas fa-times-circle"></i></div>
          <div class="card-wrap">
            <div class="card-header"><h4>Não geradas (base dia anterior)</h4></div>
            <div class="card-body">
              <div v-if="(analytics.not_generated_based_on_prev == 0 || analytics.not_generated_based_on_prev == null) && loading" class="spinner-border spinner-border-sm" role="status"></div>
              <div v-else>{{ analytics.not_generated_based_on_prev || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configData from "../../../config.js";
export default {
  props: ['log'],
  mixins: [configData],
  data() {
    return {
      analytics: {},
      loading: false
    }
  },
  mounted(){
    if(typeof this.log === 'string') this.log = JSON.parse(this.log);
    this.fetchAnalytics();
  },
  methods: {
    fetchAnalytics(){
      let _this = this;
      _this.loading = true;
      axios.post('/admin/log/generateactivity/analytics', { log: _this.log.id }).then((res) => {
        _this.analytics = res.data;
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        _this.loading = false;
      });
    }
    ,
    formatDate(date){
      try{
        if(!date) return '-';
        // use global moment available in the project
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }catch(e){
        return date || '-';
      }
    }
  }
}
</script>
